import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  
  toasts: { header:string,text: string | any,icon:string, classname?: string, delay?: number }[] = [];

  // show(textOrTpl: string | any, options: { classname?: string, delay?: number } = {}) {
  //   this.toasts.push({ textOrTpl, ...options });
  // }
  showSuccess(header:string,text:string,icon:string) {
    icon="fs-3 ti ti-checks";
    const options={classname: 'bg-success text-light', delay: 5000 };
    this.toasts.push({header,text,icon,...options} );
  }

  showError(header:string,text:string,icon:string) {
    icon="fs-3 ti ti-bomb";
    const options={ classname: 'bg-danger text-light', delay: 5000 };
    this.toasts.push({header,text,icon,...options} );
  }

  showInfo(header:string,text:string,icon:string) {
    const options={ classname: 'bg-info text-light', delay: 5000 };
    this.toasts.push({header,text,icon,...options} );
  }
  
  showWarning(header:string,text:string,icon:string) {
    const options= { classname: 'bg-warning text-dark', delay: 5000 };
    this.toasts.push({header,text,icon,...options} );
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
  clearAll() {
    this.toasts = [];
  }
  
}
